export { allowTracking, resetGtmTrackingInSamePageView } from './lib/trackingStatus';
export { addUserAttributes } from './lib/userAttributes';
export { trackPageview } from './lib/pageView';
export { trackEvent } from './lib/trackEvent';
export { trackEcommerce, trackEcommercePurchase } from './lib/ecom';
export { trackFormError } from './lib/formError';
export { trackSocial } from './lib/social';
export { getCustomDimensions } from './lib/customDimensions';
export { trackAbTestEvent } from './lib/ab';
export { trackUserTiming, trackWebVitalsEvent } from './lib/perf';
export { updateGtmPageInfo } from './lib/gtmPageInfo';
export { getSessionPageCount, incrementSessionPageCount } from './lib/sessionCount';
export { hasAction, hasCategory } from './lib/hasEventOccurred';
export { addGTMMessage } from './lib/addGTMMessage';
export { trackingConstants } from './lib/constants';

export { TrackingObject, ABTestData, EcomProduct, UserAttributes } from './lib/types';

// testing helpers
export { resetGtmTracking } from './lib/testingHelpers';
